import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-center mb-2" }
const _hoisted_3 = { class: "d-flex align-center mb-2" }
const _hoisted_4 = { class: "d-flex align-center mb-2" }
const _hoisted_5 = { class: "d-flex align-center mb-3" }

import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDeleteSubscriptionConfirm',
  props: {
    loading: { type: Boolean, default: false }
  },
  emits: ["confirmed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const confimDialog = ref(false)
const message = ref('')

onMounted(() => {
  message.value = ''
})

const onDelete = () => {
  if (props.loading) return
  // Keep the dialog open and show loading; parent controls completion via the `loading` prop.
  emit('confirmed', message.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: confimDialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confimDialog).value = $event)),
    width: "600",
    "retain-focus": false,
    persistent: __props.loading
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        size: "small",
        color: "red",
        class: "text-white"
      }), {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("キャンセル", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-red-lighten-4 text-red-darken-2 d-flex align-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "me-2" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-alert-circle", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" 現在受講中のコース閲覧ができなくなります。 ", -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    color: "red",
                    class: "me-2",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-information", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-weight-bold" }, "コースの受講ができなくなります", -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_icon, {
                    color: "red",
                    class: "me-2",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-information", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-weight-bold" }, "学習履歴が無くなります", -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    color: "red",
                    class: "me-2",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-information", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-weight-bold" }, "サポートは受けられなくなります", -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    color: "red",
                    class: "me-2",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-information", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "font-weight-bold" }, "関連する優待なども受けられなくなります", -1 /* CACHED */))
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-2 text-body-2" }, "よろしければ理由をお教えください", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "4",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
                style: {"width":"100%","border":"1px solid #ccc","border-radius":"4px","padding":"8px"}
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, message.value]
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, { class: "pa-4 pt-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                disabled: __props.loading,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (confimDialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("閉じる", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "red",
                variant: "flat",
                class: "text-white",
                loading: __props.loading,
                disabled: __props.loading,
                onClick: onDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.loading ? 'キャンセル中...' : '上を理解した上でキャンセルする'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading", "disabled"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "persistent"]))
}
}

})